@if(design){
    <p class="text-wrap"
       [ngStyle]="{
                  'font-family': '\'' + design?.font+ '\'' ,
                  'font-size': design?.fontSize + metrica,
                  'color': design.color,
                  'text-shadow': design?.shadowX + ' ' + design?.shadowY + ' ' + design.shadowZ + '% ' + design.shadowColor,
                  'margin': '0'
                }">
        @if(design.animation){
            <div class="text-container text-normal ">
                <!-- Loop over each character and apply a staggered animation delay -->
                @if(design.animation){
                    @for(char of textArray; track $index){
                        <span class="relative">

                            @if(!isEmoji(char)){
                                <span
                                        [ngStyle]="{
                                    'animation-delay': ($index * animations[design.animation]) + 's',
                                    'font-family': design?.font || 'sans-serif',
                                    'background': (design?.color || '#000'),
                                    'font-style': design?.isItalic ? 'italic' : 'normal',
                                    'font-weight': design?.isBold ? 'bold' : 'normal',
                                    'text-decoration': design?.isUnderline ? 'underline' : 'none',
                                    'font-size': (design?.fontSize || 16) + metrica,
                                    'padding': Math.max(((design?.spaceBetween || 0) / 2), 2) + 'px '
                                             + Math.max(((design?.lineHeight || 0) / 2), 2) + 'px'
                                    }"
                                            class="z-10 {{ design?.animation }} letter"
                                    >
                                  {{ char === ' ' ? '\u00A0' : char }}
                                </span>
                                <span
                                        [ngStyle]="{
                                                'animation-delay': ($index * animations[design.animation]) + 's',
                                                'text-shadow': (design?.shadowX || 0) + 'px '
                                                             + (design?.shadowY || 0) + 'px '
                                                             + (design?.shadowZ || 0) + 'px '
                                                             + (design?.shadowColor || '#000'),
                                                'font-family': design?.font || 'sans-serif',
                                                'color': 'transparent',
                                                'font-style': design?.isItalic ? 'italic' : 'normal',
                                                'font-weight': design?.isBold ? 'bold' : 'normal',
                                                'text-decoration': design?.isUnderline ? 'underline' : 'none',
                                                'font-size': (design?.fontSize || 16) + metrica,
                                                'padding': Math.max(((design?.spaceBetween || 0) / 2), 2) + 'px '
                                                         + Math.max(((design?.lineHeight || 0) / 2), 2) + 'px'
                                        }"
                                            class=" z-0 letter !absolute top-0 left-0 {{ design?.animation }}"
                                    >
                                  {{ char === ' ' ? '\u00A0' : char }}
                                </span>
                            } @else {
                                <span
                                        [ngStyle]="{
                                    'animation-delay': ($index * animations[design.animation]) + 's',
                                    'font-style': design?.isItalic ? 'italic' : 'normal',
                                    'font-weight': design?.isBold ? 'bold' : 'normal',
                                    'text-decoration': design?.isUnderline ? 'underline' : 'none',
                                    'font-size': (design?.fontSize || 16) + metrica,
                                    'text-shadow': (design?.shadowX || 0) + 'px '
                                             + (design?.shadowY || 0) + 'px '
                                             + (design?.shadowZ || 0) + 'px '
                                             + (design?.shadowColor || '#000'),
                                    'padding': Math.max(((design?.spaceBetween || 0) / 2), 2) + 'px '
                                             + Math.max(((design?.lineHeight || 0) / 2), 2) + 'px'
                                    }"
                                        class="z-10 {{ design?.animation }}"
                                >
                                  {{ char === ' ' ? '\u00A0' : char }}
                                </span>
                            }
                        </span>

                    }
                } @else {
                    {{text}}
                }

            </div>
        } @else {
            {{text}}
        }
    </p>
} @else {
    <p>
        {{text}}
    </p>
}
